import React from 'react';

const GameStyles: React.FC = () => (
  <style>
    {`
      .game-header {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 20;
        background: linear-gradient(to bottom, rgba(0,0,0,0.5), transparent);
      }

      .progress-bar-in-header {
        width: 100%;
        height: 4px;
        background-color: rgba(255, 255, 255, 0.2);
        z-index: 21;
      }

      .game-header-content {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
      }

      .level-info-left {
        position: absolute;
        left: 20px;
        font-size: 1.4em;
        font-weight: bolder;
        color: #FFC107;
        text-shadow: 0 0 15px rgba(255, 193, 7, 0.8);
      }

      .taps-info-center {
        font-size: 1.4em;
        font-weight: bolder;
        color: white;
        text-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
      }

      .level-indicator {
        font-size: 1.2em;
        font-weight: bold;
        color: #FFC107;
        text-shadow: 0 0 10px rgba(255, 193, 7, 0.5);
        text-align: center;
      }

      .progress-bar-full-width {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background-color: rgba(255, 255, 255, 0.2);
        z-index: 21;
      }

      .progress-fill {
        height: 100%;
        background-color: #FFC107;
        box-shadow: 0 0 10px rgba(255, 193, 7, 0.5);
        transition: width 0.1s linear;
      }

      .taps-remaining {
        display: flex;
        gap: 5px;
        font-size: 1.2em;
        color: white;
        text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
      }

      .taps-remaining-icons {
        display: flex;
        gap: 5px;
        font-size: 1.5em; /* Larger icons */
      }

      /* UPDATED: Rescue-themed tap icons */
      .rescue-tap-icon {
        color: #FFC107; /* Color of the rescue icon */
        text-shadow: 0 0 5px rgba(255, 193, 7, 0.5);
        animation: rescueIconPulse 2s ease-in-out infinite;
      }

      /* Legacy bee tap icon for backward compatibility */
      .bee-tap-icon {
        color: #FFC107; /* Color of the bee icon */
        text-shadow: 0 0 5px rgba(255, 193, 7, 0.5);
      }

      @keyframes rescueIconPulse {
        0%, 100% { 
          transform: scale(1); 
          filter: brightness(1);
        }
        50% { 
          transform: scale(1.1); 
          filter: brightness(1.3);
        }
      }

      .game-start-screen {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        color: white;
        z-index: 10;
        background: rgba(0, 0, 0, 0.7);
        padding: 30px;
        border-radius: 15px;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
      }

      .game-start-screen h1 {
        font-size: 2em;
        margin-bottom: 20px;
        color: #FFC107;
        text-shadow: 0 0 10px rgba(255, 193, 7, 0.5);
      }

      .stats {
        margin: 20px 0;
        color: #FFC107;
      }

      .start-button {
        background: #FFC107;
        color: black;
        border: none;
        padding: 12px 30px;
        font-size: 1.2em;
        border-radius: 25px;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0 0 15px rgba(255, 193, 7, 0.5);
      }

      .start-button:hover {
        transform: scale(1.05);
        box-shadow: 0 0 20px rgba(255, 193, 7, 0.7);
      }

      .start-button:active {
        transform: scale(0.95);
      }

      /* NEW: Rescue-themed animations and styles */
      .rescue-theme {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      }

      .ufo-glow {
        animation: ufoGlow 3s ease-in-out infinite;
      }

      @keyframes ufoGlow {
        0%, 100% { filter: brightness(1) drop-shadow(0 0 5px rgba(123, 104, 238, 0.5)); }
        50% { filter: brightness(1.2) drop-shadow(0 0 15px rgba(123, 104, 238, 0.8)); }
      }

      .rescue-success-text {
        color: #4CAF50;
        font-weight: bold;
        text-shadow: 0 0 10px rgba(76, 175, 80, 0.8);
        animation: rescueTextGlow 2s ease-in-out infinite;
      }

      @keyframes rescueTextGlow {
        0%, 100% { text-shadow: 0 0 10px rgba(76, 175, 80, 0.8); }
        50% { text-shadow: 0 0 20px rgba(76, 175, 80, 1); }
      }
    `}
  </style>
);

export default GameStyles; 